//funzione per creare il menù che si apre premendo i tre puntini accanto a ogn servizio e ogni layer 
import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import moreHorizIcon from './menu.svg';
import SliderItem from './ActionLayer/SliderItem'
import { connect } from 'react-redux';
import { selectNodes, setAttributi, setOpenQuery } from '../../../redux';
import UpDownLayer from './ActionLayer/UpDownLayer'
import UpDownService from './ActionLayer/UpDownService'
import { Trans } from 'react-i18next';
 function MoreButton(props) {
  
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const openQueryDrawer =() =>{
    props.setOpenQuery({state:true,name:props.nodes.name})
    setAnchorEl(null);
  }
  const handleClose = () => {
    setAnchorEl(null);
  };

  const zoomTo = () => {
    props.selectNodes(props.nodes)
    
  }
  // const openAttributi = ()=>{
  //   props.setAttributi({state:true,value: props.nodes})
  //   setAnchorEl(null);
  // }

  const openXmlLayer = () =>{

    try { 
      var url = props.nodes.serviceUrl
      let len = url.lastIndexOf('/') + 1
      var output = url.substring(0, len) + `${props.nodes.name}/` + url.substring(len);
      window.open(output + "&request=GetCapabilities", "_blank")
    } catch (error) {
      
    }
  }

  const openXmlService = () =>{

    try {
      window.open(props.nodes.element.serviceUrl + "&request=GetCapabilities", "_blank")
    } catch (error) {
      
    }
  }
  const menuType = () =>{
    
    if (props.nodes.element === undefined){
      
      return (<div>
                <MenuItem onClick={zoomTo}><Trans>Zoom To</Trans></MenuItem>
                <SliderItem nodes={props.nodes}/>
                <UpDownLayer nodes={props.nodes}/>
                <MenuItem onClick={openXmlLayer}><Trans>Visualizza XML</Trans></MenuItem>
                {/* <MenuItem onClick={openAttributi}><Trans>Visualizza nella tabella degli attributi</Trans></MenuItem> */}
                <MenuItem onClick={openQueryDrawer}><Trans>Effettua query</Trans></MenuItem>
              </div>)
    }else {
      return (<div>
                <MenuItem onClick={openXmlService}><Trans>Visualizza XML</Trans></MenuItem>
                <UpDownService nodes={props.nodes} />
                {/* <MenuItem onClick={openAttributi}><Trans>Visualizza nella tabella degli attributi</Trans></MenuItem> */}
                
              </div>)
    }
  }

  return (
    <div>
<button className={"buttonItem"} onClick={handleClick}><img style={{width: '22px',height: '22px'}} src={moreHorizIcon} alt="more"></img></button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
          {menuType()}
      </Menu>
    </div>
  );
}

const mapStateToProps = state => {
  return {
      zoomTo: state.zoomTo,
      attributi: state.attributi,
      openQuery:state.openQuery
  }
}
const mapDispatchToProps = dispatch => {
  return {
    selectNodes: (nodesTo) => dispatch(selectNodes(nodesTo)),
    setAttributi: (attributi) =>dispatch(setAttributi(attributi)),
    setOpenQuery: (openQuery) => dispatch(setOpenQuery(openQuery))
   }
}
export default connect(mapStateToProps,mapDispatchToProps) (MoreButton)